import React, { useEffect, useState } from "react";
import MessageCard from "../components/Messages/MessageCard";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { MESSAGES_API } from "../api/MessagesApi";
import { setPageTitle } from "../slice";
import InfiniteScroll from "../components/InfiniteScroll";

function Messages() {
  const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE;
  const dispatch = useDispatch();
  const [messages, setMessages] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const { isLoading } = useQuery(
    ["GetAllMessages", page],
    () => MESSAGES_API.GetAllMessages(page * PAGE_SIZE, PAGE_SIZE),
    {
      onSuccess: ({ data }) => {
        if (data.success) {
          let temp = [...messages, ...data.data.data];
          setHasMore(temp.length < data.data.totalCount);
          setMessages(temp);
        } else {
          //todo:inja byd error ha handle beshan
        }
      },
    }
  );

  useEffect(() => {
    dispatch(setPageTitle("پیام‌ها"));
  }, [dispatch]);

  return (
    <InfiniteScroll
      hasMore={hasMore}
      loadMore={() => setPage((prev) => prev + 1)}
      scrollTarget="scrollable_div"
      isLoading={isLoading}
      dataLength={messages.length}
    >
      <Box display="flex" flexDirection={"column"} width="100%" alignItems={"center"}>
        {messages.map((messageItem) => (
          <MessageCard key={messageItem.id} {...messageItem} />
        ))}
      </Box>
    </InfiniteScroll>
  );
}

export default Messages;
